// TODO: Update getAllActiveAppsURI, getAllActiveDemandPartnersURI with new endpoint once it's ready. The current endpoint is a temporary solution and should be replaced.
export const getAllActiveAppsURI = '/inventory-management/getAllActiveApps';
export const getAllActiveDemandPartnersURI = '/partner/getAllDemandPartners?isActive=2';
export const getAllActivePublishersURI = '/inventory-management/getAllActivePublishers';
// TODO: inventory service is closed as of now. so this api wont run
export const getAppsBySpIdURI = (spId:string)=>`/inventory/app/getAppsDetails?spid=${spId}`
